// Estimated Universal Key cost per AI image action. Keep in sync with backend AI_IMAGE_CREDITS / AI_CREDIT_USD.
export const AI_IMAGE_COST = { credits: 100, usd: 2 };

// Shows a confirmation with the estimated credit + dollar cost before an AI action runs.
export const confirmAiCost = (label = "This AI action") =>
  window.confirm(`${label} will use ~${AI_IMAGE_COST.credits} credits (~$${AI_IMAGE_COST.usd}) from your Universal Key. This is logged for your expense reports. Continue?`);
